import React from 'react';
import clsx from 'clsx';
import { createStyles } from './styles';

interface Props {
  title: string;
  contentStyle?: string;
  children: React.ReactNode;
}

const Section: React.FC<Props> = ({ title, children, contentStyle }) => {
  const classes = createStyles();
  return (
    <section className={clsx(classes.section, classes.bcSection)}>
      {title && <h2 className={classes.title}>{title}</h2>}
      <div className={clsx(classes.contentWrapper, contentStyle)}>{children}</div>
    </section>
  );
};

export default Section;
